import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons } from "@components";
import { UploadDocumentForm } from "./UploadDocumentForm";

import { UploadFileType } from "@type/HRM/upload-file";
import { OtherAttachedFilesFormDataType } from "@validations/HRM/employee/attachedFiles";

interface NewUploadDocumentPropsType {
  handleNewUploadDocumentFormShow: (param: boolean) => void;
  createAttachedFile: (data: UploadFileType) => void;
  updateAttachedFileRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const NewUploadDocument = ({
  handleNewUploadDocumentFormShow,
  createAttachedFile,
  updateAttachedFileRequestOngoing,
  isProfileDisabled,
}: NewUploadDocumentPropsType) => {
  const methods = useForm<OtherAttachedFilesFormDataType>();

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<OtherAttachedFilesFormDataType> = (
    data: OtherAttachedFilesFormDataType,
  ) => {
    const { documentName, memorialNo, remarks, date, attachmentDocument } =
      data as OtherAttachedFilesFormDataType;
    createAttachedFile({
      ...attachmentDocument,
      documentName,
      memorialNo,
      remarks,
      date,
    });
    handleNewUploadDocumentFormShow(false);
  };

  return (
    <FormProvider {...methods}>
      <form className="container" onSubmit={handleSubmit(onSubmit)}>
        <UploadDocumentForm isProfileDisabled={isProfileDisabled} />
        {!isProfileDisabled && (
          <ActionButtons
            isSaving={updateAttachedFileRequestOngoing}
            disabled
            closeAction={() => handleNewUploadDocumentFormShow(false)}
          />
        )}
      </form>
    </FormProvider>
  );
};
